import { observable } from 'mobx';

export type ArrangementRequestResponseArgs = {
  id: number;
};

export type ArrangementRequestArgs = {
  id: number;
};

export const convertArrangementRequestResponseToArgs = (response: ArrangementRequestResponseArgs) => {
  const args: ArrangementRequestArgs = {
    id: response.id
  };
  return args;
};

export default class ArrangementRequest {
  @observable
  id: number;

  constructor(args: ArrangementRequestArgs) {
    this.id = args.id;
  }
}
